<template>
  <div>
    <!-- MODAL DE UNA FECHA -->
    <DatePickerDialog
      v-if="activeDatePicker"
      :active="activeDatePicker"
      :date="dateSearch"
      module="productivityReport"
      :searchType="searchType"
      @dialog:change="eventdialog"
    ></DatePickerDialog>

    <!-- MODAL DE AGENTES -->
    <AgentPicker
      v-if="agentDialogActive"
      :active="agentDialogActive"
      module="productivityReport"
      :searchType="searchType"
      @dialog:change="eventdialog"
    ></AgentPicker>

    <!-- MODAL DE RANGO DE FECHA -->
    <!-- <SimpleDateRangePicker
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      module="productivityReport"
      @dialog:change="eventdialog"
    ></SimpleDateRangePicker> -->

    <v-row justify="space-between" align="center">
      <v-col cols="12" md="auto">
        <v-btn color="accent shadow-4 px-8" rounded large @click.stop="openDialog"
          >Consultar</v-btn
        >
      </v-col>

      <!-- <v-col v-if="searchType == 'agent'" cols="12" md="auto">
        <span class="caption grey--text">Fecha:</span>
        {{ dateSearch.date | dateFormat }}
      </v-col> -->
      <!-- <v-col v-if="searchType == 'range'" cols="12" md="auto">
        <span class="caption grey--text">Fecha:</span>
        {{ dateSearch[0] | dateFormat }} - {{ dateSearch[1] | dateFormat }}
      </v-col>
      <v-col v-else cols="12" md="auto">
        <span class="caption grey--text">Fecha:</span>
        {{ dateSearch | dateFormat }}
      </v-col> -->

      <v-col v-if="searchType == 'date'" cols="auto" class="ml-auto">
        <v-switch v-model="activeGraph" inset label="Ver gráficas"></v-switch>
      </v-col>
    </v-row>
    <!-- {{ productivityReportInfo }} -->
    <v-card class="shadow-1 mt-5" v-show="!activeGraph && dateSearch !== ''">
      <!-- Tabla -->
      <v-container>
        <v-row dense justify="end">
          <v-col cols="12">
            <vuescroll
              :ops="{
                bar: {
                  background: '#bacfcec0',
                  keepShow: true,
                },
              }"
            >
              <v-data-table
                :headers="headers"
                :items="productivityReportInfo"
                class="elevation-0"
                :loading="isLoading"
                :server-items-length="totalItems"
                :footer-props="{
                  'items-per-page-options': [50, 100],
                }"
                hide-default-footer
                hide-default-header
                :page.sync="options.page"
                @page-count="pageCount = $event"
              >
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th v-for="header in headers" :key="header.text">
                        <v-tooltip bottom :disabled="!header.tooltip">
                          <template #activator="{ on }">
                            <span v-on="on" class="primary--text">{{ header.text }}</span>
                          </template>
                          <span>{{ header.tooltip }}</span>
                        </v-tooltip>
                      </th>
                    </tr>
                  </thead>
                </template>
              </v-data-table>
            </vuescroll>
          </v-col>
          <v-col cols="12" md="auto" class="v-data-footer">
            <!-- <v-row dense align="center"> -->
            <v-col class="v-data-footer__select">
              <span>Filas por página:</span>
              <v-select
                class="ml-3"
                :items="[50, 100, 150]"
                v-model="options.itemsPerPage"
                @change="getProductivityReport"
                style="width: 60px"
                hide-details
              >
              </v-select>
            </v-col>

            <v-col>
              <v-pagination
                circle
                color="primary"
                v-model="options.page"
                :length="pageCount"
                total-visible="1"
              ></v-pagination>
            </v-col>
            <!-- </v-row> -->
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <!-- Gráficas -->
    <v-container v-if="activeGraph" fluid>
      <v-row align="center" justify="center">
        <v-col v-if="render && activeGraphGeneral" cols="12">
          <v-card class="shadow-1">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal"
            >
              Llamadas entrantes por extensión (Segundos)
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart1"
                type="bar"
                :options="optionStackedBar"
                :series="IncomingCallsGraphData"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-else cols="12">
          <v-skeleton-loader transition="scale-transition" class="mx-auto" type="card">
          </v-skeleton-loader>
        </v-col>

        <v-col v-if="render && activeGraphGeneral" cols="12">
          <v-card class="shadow-1 mt-5">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal"
            >
              Tiempo muerto por extensión (Segundos)
            </v-card-title>
            <v-card-text>
              <apexchart
                ref="chart2"
                type="bar"
                :options="optionBar"
                :series="deadTimeGraphData"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-else cols="12">
          <v-skeleton-loader transition="scale-transition" class="mx-auto" type="card">
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import moment from "moment";

import DatePickerDialog from "@/components/DatePickers/DatePicker.vue";
import AgentPicker from "@/components/DatePickers/AgentPicker.vue";
// import SimpleDateRangePicker from "@/components/DatePickers/SimpleDateRangePicker.vue";

export default {
  name: "ProductivityReport",

  components: {
    DatePickerDialog,
    AgentPicker,
    // SimpleDateRangePicker,
    vuescroll,
  },

  data() {
    return {
      isLoading: false,
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 50,
      },
      // End for pagination
      page: 1,
      pageCount: 1,
      render: false,
      activeGraph: false,
      activeGraphGeneral: true,
      // activeGraphDeadTime: true,
      activeDatePicker: false,
      rangeDialogActive: false,
      agentDialogActive: false,
      searchType: null,
      headers: [
        {
          text: "Agente",
          tooltip: "Agente",
          value: "user.name",
          width: "300px",
          class: "primary--text",
        },
        {
          text: "Extensión",
          tooltip: "Extensión utilizada por el agente.",
          value: "user.extension",
          sortable: false,
          width: "50px",
          class: "primary--text",
        },
        {
          text: "H. Entrada",
          tooltip: "Hora en que inicia la sesión por primera vez en la plataforma.",
          value: "hour_entry",
          width: "100px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "H. Salida",
          tooltip: "Hora en la que hace su último cierre de sesión del día.",
          value: "hour_exit",
          width: "100px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "T. Trabajado",
          tooltip: "Acumulado de tiempos activos durante el día de trabajo.",
          value: "shift_duration",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "D. Turno",
          tooltip: "Duración del turno.",
          align: "right",
          value: "time_out",
          width: "150px",
          class: "primary--text",
        },
        {
          text: "D. Pausas",
          tooltip: "Duración total de las pausas realizadas en el día.",
          value: "pause_duration",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "Primera llamada salida",
          tooltip: "Hora en la que el agente realiza su primera llamada en el día.",
          value: "first_call_out",
          width: "100px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "Última llamada salida",
          tooltip: "Hora en la que el agente realiza la última llamada en el día.",
          value: "last_call_out",
          width: "100px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "Primera llamada cola",
          tooltip: "Hora en la que el agente atiende su primera llamada en cola",
          align: "right",
          value: "first_call_queue",
          width: "150px",
          class: "primary--text",
        },
        {
          text: "Última llamada cola",
          tooltip: "Hora en la que el asesor atiende su última llamada en cola",
          align: "right",
          value: "last_call_queue",
          width: "150px",
          class: "primary--text",
        },
        {
          text: "T. Hablado salida",
          tooltip: "Tiempo total hablado en llamadas de salida.",
          value: "spoken_exit",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "T. Hablado cola entrada",
          tooltip: "Tiempo total hablado en llamadas de entrada a través de cola",
          align: "right",
          value: "spoken_queue_entrance",
          width: "170px",
          class: "primary--text",
        },
        {
          text: "T. Hablado entrada directa",
          tooltip: "Tiempo total hablado en llamadas de entrada directas a la extensión.",
          align: "right",
          value: "spoken_direct_entry",
          width: "170px",
          class: "primary--text",
        },
        {
          text: "T. Total hablado",
          tooltip: "Tiempo total hablado durante el día.",
          align: "right",
          value: "time_total_spoken",
          width: "15%",
          class: "primary--text",
        },
        {
          text: "T. En uso",
          tooltip: "Tiempo total hablado mas el tiempo en ring",
          value: "time_in_use",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "T. Inactivo",
          tooltip: "Tiempo trabajado menos el tiempo en uso",
          value: "time_inactive",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "T. Ring",
          tooltip: "Tiempo total en ring durante el día",
          value: "time_in_ring",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "Llamada máxima",
          tooltip: "La llamada de mayor duración, realizada por el agente en el día.",
          value: "maximum_call",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "T. llamada salida",
          tooltip: "Tiempo total de llamadas de salida incluyendo el ring.",
          value: "time_call_out",
          width: "150px",
          align: "right",
          class: "primary--text",
        },
        {
          text: "Cant. llamada salida",
          tooltip: "Cantidad de llamadas de salida realizada por el agente.",
          align: "right",
          value: "total_call_out",
          width: "15%",
          class: "primary--text",
        },
        {
          text: "Cant. llamada entrada cola",
          tooltip: "Cantidad de llamadas de entrada por cola atendidas por el agente.",
          align: "right",
          value: "number_call_queue",
          width: "15%",
          class: "primary--text",
        },
        {
          text: "Cant. llamada entrada directa",
          tooltip:
            "Cantidad de llamadas de entrada directas a la extensión de el agente.",
          align: "right",
          value: "total_call_int",
          width: "15%",
          class: "primary--text",
        },
        {
          text: "Total de llamadas",
          tooltip: "Cantidad total de llamadas procesadas por el agente en el día.",
          value: "total_calls",
          width: "100px",
          class: "primary--text",
        },
        {
          text: "AHT",
          tooltip:
            "Promedio de tiempo hablado entre todas las llamadas realizadas en el día por el agente.",
          value: "aht",
          width: "100px",
          class: "primary--text",
        },
      ],
      dateSearch: new moment().format("YYYY-MM-DD"),
      productivityReportInfo: [],
      optionStackedBar: {
        chart: {
          //   type: 'bar',
          //   height: 350,
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        // responsive: [
        //     {
        //         breakpoint: 480,
        //         options: {
        //             legend: {
        //                 position: "bottom",
        //                 offsetX: -10,
        //                 offsetY: 0
        //             }
        //         }
        //     }
        // ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      optionBar: {
        chart: {
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        // responsive: [
        //     {
        //         breakpoint: 480,
        //         options: {
        //             legend: {
        //                 position: "bottom",
        //                 offsetX: -10,
        //                 offsetY: 0
        //             }
        //         }
        //     }
        // ],
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 10,
          },
        },
        xaxis: {
          categories: [],
        },
      },
      IncomingCallsGraphData: [
        {
          name: "Llamada salida",
          data: [],
        },
        {
          name: "Tiempo ring",
          data: [],
        },
        {
          name: "Llamada cola",
          data: [],
        },
        {
          name: "Pausas",
          data: [],
        },
      ],
      deadTimeGraphData: [
        {
          name: "Tiempo muerto",
          data: [],
        },
      ],
    };
  },

  watch: {
    "$route.params.type": function(newVal, oldVal) {
      // this.searchType = this.$route.params.type;
      // if (newVal === "agent") {
      //   this.agentDialogActive = true;
      //   // this.activeDatePicker = false;
      // } else {
      //   // Otro caso, puedes manejarlo según tus necesidades
      //   this.activeDatePicker = true;
      //   // this.agentDialogActive = false;
      // }
      location.reload();
    },
    // page(newVal) {
    //     this.getProductivityReport(newVal);
    // }
    options: {
      handler() {
        this.getProductivityReport();
      },
      deep: true,
    },
  },

  mounted() {
    this.searchType = this.$route.params.type;
    // console.log(this.searchType);
    // this.activeDatePicker = true;
    switch (this.searchType) {
      // case "date":
      //   this.activeDatePicker = true;
      //   break;
      // case "range":
      //   this.rangeDialogActive = true;
      //   break;
      case "agent":
        this.agentDialogActive = true;
        break;

      default:
        this.activeDatePicker = true;
        break;
    }
  },

  methods: {
    eventdialog(value, dataSearch) {
      if (value !== "close") {
        // if (this.searchType === "date") {
        //   this.dateSearch = dataSearch;
        // } else if (this.searchType === "range") {
        //   this.dateSearch = dataSearch;
        // } else {
        //   this.dateSearch = dataSearch;
        // }
        this.dateSearch = dataSearch;

        this.getProductivityReport(dataSearch);
      }
      // else {
      this.activeDatePicker = false;
      this.agentDialogActive = false;
      // }
    },

    openDialog() {
      if (this.$route.params.type == "agent") {
        this.agentDialogActive = true;
      } else {
        this.activeDatePicker = true;
      }
    },

    getProductivityReport(dataSearch) {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      let params = {
        page,
        itemPerPage: itemsPerPage,
      };
      // console.log("aqui", dataSearch);
      if (this.$route.params.type == "date") {
        params.date = this.dateSearch;
      } else if (this.$route.params.type == "range") {
        params.date = this.dateSearch[0];
        params.dateEnd = this.dateSearch[1];
      } else if (this.$route.params.type == "agent") {
        params.date = this.dateSearch.date;
        params.dateEnd = this.dateSearch.dateEnd;
        params.user_id = this.dateSearch.user_id;
      }

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/sumary_histories_agent`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params,
        })
        .then((res) => {
          this.productivityReportInfo = Object.values(res.data.data);
          this.totalItems = res.data.total;
          this.pageCount = res.data.last_page;
          // console.log("estototorot", res.data.data);
          this.productivityReportInfo.pop();

          // //Obtenemos fecha de consulta
          // this.dateSearch = search;

          this.activeDatePicker = false;

          if (this.$route.params.type === "date") {
            this.getIncomingCallsGraphData(params.date);
          }

          const shiftLength = this.productivityReportInfo.shift_duration
            ? this.productivityReportInfo.shift_duration
            : "00:00:00";

          const OutgoingCallsTime = this.productivityReportInfo.time_call_out
            ? parseInt(this.productivityReportInfo.time_call_out)
            : 0;

          const SpokenQueueIncomingCalls = this.productivityReportInfo.time_total_spoken
            ? parseInt(this.productivityReportInfo.time_total_spoken)
            : 0;
          // const SpokenQueueIncomingCalls = this.productivityReportInfo.map(
          //     agent =>
          //         this.findExtensionQueue(
          //             agent.queues[0].csr,
          //             agent.extension
          //         ).Hablado
          // );
          this.deadTimeGraph(shiftLength, OutgoingCallsTime, SpokenQueueIncomingCalls);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$snotify.error("Su sesion ha finalizado.", "Error");
            this.$store.dispatch("passport/RESET_AUTH");
            this.$router.push({ name: "login" });
            return;
          }
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getIncomingCallsGraphData(search) {
      // this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      const params = {
        date: search,
      };

      // if (this.searchType == "date") {
      //   params.date = this.dateSearch;
      // } else if (this.searchType == "range") {
      //   params.date = this.dateSearch[0];
      //   params.dateEnd = this.dateSearch[1];
      // } else if (this.searchType == "agent") {
      //   params.user_id = this.dateSearch;
      // }

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/get_agente_grafica`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params,
        })
        .then((res) => {
          // Grafica de llamadas entrantes por extension
          this.optionStackedBar.xaxis.categories = res.data[0].agents;
          this.IncomingCallsGraphData[0].data = res.data[1].values;
          this.IncomingCallsGraphData[1].data = res.data[2].values;
          this.IncomingCallsGraphData[2].data = res.data[3].values;
          // Pausas
          // const pauses = this.pausesCount(res.data[4].values);
          this.IncomingCallsGraphData[3].data = res.data[4].values;

          // Grafica de tiempo muerto por extension
          this.optionBar.xaxis.categories = res.data[0].agents;
        })
        .catch((error) => {
          //   console.error(error);
          this.$snotify.error("Hubo un error en la consulta para la grafica.", "Error");
        })
        .finally(() => {
          this.render = true;
          // this.activeGraphGeneral = true/;
        });
    },

    findExtensionQueue(queues, extension) {
      const result = queues.find((item) => item.agent === `SIP/${extension}`);

      return result;
    },

    getHourFormat(date) {
      const hour = date.toString().slice(-8);

      return hour;
    },

    pausesCount(userPause) {
      // Extraemos la llave duration de todos los elementos y liminamos los elementos nulos
      let array = userPause.map((pause) => pause).filter(Boolean);

      let toSeconds = array
        .map((pause) =>
          moment(pause, "HH:mm:ss").diff(moment().startOf("day"), "seconds")
        )
        .filter(Boolean);

      if (toSeconds.shiftLength > 1)
        toSeconds.reduce((previousValue, CurrentValue) => previousValue + CurrentValue);

      return toSeconds;
    },

    /**
     * [Cálculo del tiempo muerto (Dead Time)]
     * @param {string} shiftLength [Duración turno]
     * @param {string} OutgoingCallsTime [Tiempo llamada salida]
     * @param {string} SpokenQueueIncomingCalls [Hablado cola entrada]
     */
    deadTime(shiftLength = 0, OutgoingCallsTime = 0, SpokenQueueIncomingCalls = 0) {
      let shiftLengthtoSeconds = moment(shiftLength, "HH:mm:ss").diff(
        moment().startOf("day"),
        "seconds"
      );

      let deadTime = shiftLengthtoSeconds - OutgoingCallsTime - SpokenQueueIncomingCalls;

      // Hacemos push a los datos para la grafica (En segundos)
      // this.deadTimeGraphData[0].data.push(deadTime);

      // Transformamos el tiempo muerto de segundos a 00h 00m 00s
      let date = new Date(null);
      date.setSeconds(deadTime);
      let time = date.toISOString().substr(11, 8);

      let result = time.split(":");

      result[0] = result[0] + "h";
      result[1] = result[1] + "m";
      result[2] = result[2] + "s";

      result = result.filter((value) => !value.startsWith("00"));

      return result.join(" ");
    },

    deadTimeGraph(shiftLength = 0, OutgoingCallsTime = 0, SpokenQueueIncomingCalls = 0) {
      for (const [element, index] of shiftLength) {
        // Transformamos de HH:MM:SS a segundos
        const shiftLengthtoSeconds = moment(element, "HH:mm:ss").diff(
          moment().startOf("day"),
          "seconds"
        );

        // Calculamos el tiempo muerto por extension
        const deadTime =
          shiftLengthtoSeconds -
          OutgoingCallsTime[index] -
          SpokenQueueIncomingCalls[index];

        // Hacemos push a los datos para la grafica (En segundos)
        this.deadTimeGraphData[0].data.push(Math.abs(deadTime));
      }

      // console.info("erer", deadTime);
    },
  },
};
</script>
